// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/MensagensProgramadas_GetBulkProgressInput.php
// Do not edit by hand — edit the PHP InputContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * InputContract for GET /mensagens_programadas/get_bulk_progress
 *
 * Required group_id to fetch scheduler-service progress stats for a bulk batch.
 */
import { registerContract } from './validate'

export interface MensagensProgramadas_GetBulkProgressInput {
group_id: string
}

registerContract('MensagensProgramadas_GetBulkProgressInput', {
  group_id: { type: 'string',  required: true },
})
